var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1092_13845)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.72266,
    y: 0.5,
    width: 15.6667,
    height: 19,
    rx: 2.5,
    fill: "#25245E",
    stroke: "#25245E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 15.5558V14.0743C15.5557 13.2885 15.2923 12.5348 14.8234 11.9792C14.3546 11.4235 13.7187 11.1113 13.0557 11.1113H8.05566C7.39262 11.1113 6.75674 11.4235 6.2879 11.9792C5.81906 12.5348 5.55566 13.2885 5.55566 14.0743V15.5558",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 15.5558V14.0743C15.5557 13.2885 15.2923 12.5348 14.8234 11.9792C14.3546 11.4235 13.7187 11.1113 13.0557 11.1113H8.05566C7.39262 11.1113 6.75674 11.4235 6.2879 11.9792C5.81906 12.5348 5.55566 13.2885 5.55566 14.0743V15.5558H15.5557Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5556 8.88905C12.0897 8.88905 13.3334 7.6454 13.3334 6.11127C13.3334 4.57715 12.0897 3.3335 10.5556 3.3335C9.02149 3.3335 7.77783 4.57715 7.77783 6.11127C7.77783 7.6454 9.02149 8.88905 10.5556 8.88905Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22244 4.44434H1.11133",
    stroke: "#25245E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22244 10H1.11133",
    stroke: "#25245E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22244 15.5557H1.11133",
    stroke: "#25245E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_13845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsList);
export default __webpack_public_path__ + "static/media/contactsList.65affe8d4a886d8c4073408943a85f2b.svg";
export { ForwardRef as ReactComponent };